<template>
  <div>
    <div class="login-body">
      <div class="mask" />
      <div class="login-container">
        <div class="login-main">
          <div class="close" @click="handleClose">
            <svg-icon icon-class="close" />
          </div>
          <div class="login-left">
            <div class="logo">
              <span v-show="false" class="logoImg" />
              <p>{{ portalInfo.title }}</p>
            </div>
            <div class="text-sub">
              <h1 />
              <p class="cn">
                登录访问更多
              </p>
              <p class="en">
                Good to see you again！
              </p>
            </div>
          </div>
          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            class="login-form"
            auto-complete="off"
            autocomplete="off"
            label-position="left"
          >
            <div class="login-title">
              用户登录<span class="title-en">USER LOGIN</span>
            </div>
            <el-form-item prop="account">
              <span class="svg-container">
                <svg-icon icon-class="user" />
              </span>
              <el-input
                v-model="loginForm.account"
                :maxlength="18"
                name="account"
                type="text"
                auto-complete="off"
                class="login-input"
                placeholder="用户名"
                clearable
                @keyup.enter.native="handleLogin"
              />
            </el-form-item>
            <el-form-item prop="pwd">
              <span class="svg-container">
                <svg-icon icon-class="password" />
              </span>
              <el-input
                v-model="loginForm.pwd"
                :type="pwdType"
                name="pwd"
                auto-complete="off"
                autocomplete="off"
                placeholder="密码"
                class="login-input"
                @keyup.enter.native="handleLogin"
              />
              <span class="show-pwd" @click="showPwd">
                <svg-icon :icon-class="pwdType === 'password' ? 'eye' : 'eye-open'" />
              </span>
              <!-- <el-tooltip effect="dark" content="初始密码为：cunw + 手机号后4位" placement="top">
              <i class="el-icon-question" />
            </el-tooltip>-->
            </el-form-item>
            <span class="tip">忘记密码，请联系管理员重置</span>
            <el-form-item class="login-bnt">
              <el-button :loading="loading" type="primary" @click.native.prevent="handleLogin">
                登 录
              </el-button>
            </el-form-item>
            <div class="copy-right">
              <div>Copyrightwww.cunwedu.com.cn,All Rights</div>
              <div v-show="portalInfo.footCopyright" :title="portalInfo.footCopyright">
                {{ portalInfo.footCopyright }}
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <div class="login-body-h5">
      <div class="login-container-h5">
        <div class="p1">
          克什克腾旗
        </div>
        <div class="p1">
          智慧教育云门户
        </div>
        <div class="p2">
          keshiketeng banner wisdom education cloud portal
        </div>
        <div class="login-main">
          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            class="login-form"
            auto-complete="off"
            autocomplete="off"
            label-position="left"
          >
            <el-form-item prop="account">
              <span class="svg-container">
                <svg-icon icon-class="user" />
              </span>
              <el-input
                v-model="loginForm.account"
                :maxlength="18"
                name="account"
                type="text"
                auto-complete="off"
                class="login-input"
                placeholder="用户名"
                clearable
                @keyup.enter.native="handleLogin"
              />
            </el-form-item>
            <el-form-item prop="pwd">
              <span class="svg-container">
                <svg-icon icon-class="password" />
              </span>
              <el-input
                v-model="loginForm.pwd"
                :type="pwdType"
                name="pwd"
                auto-complete="off"
                autocomplete="off"
                placeholder="密码"
                class="login-input"
                @keyup.enter.native="handleLogin"
              />
              <span class="show-pwd" @click="showPwd">
                <svg-icon :icon-class="pwdType === 'password' ? 'eye' : 'eye-open'" />
              </span>
              <!-- <el-tooltip effect="dark" content="初始密码为：cunw + 手机号后4位" placement="top">
            <i class="el-icon-question" />
          </el-tooltip>-->
            </el-form-item>
            <div class="tip">
              忘记密码，请联系管理员重置
            </div>
            <el-form-item class="login-bnt">
              <el-button :loading="loading" type="primary" @click.native.prevent="handleLogin">
                登 录
              </el-button>
            </el-form-item>
            <el-form-item class="login-bnt" style="margin-top: 0;">
              <el-button :loading="loading" @click.native.prevent="handleClose">
                取 消
              </el-button>
            </el-form-item>
            <div class="copy-right">
              <div>Copyrightwww.cunwedu.com.cn,All Rights</div>
              <div v-show="portalInfo.footCopyright" :title="portalInfo.footCopyright">
                {{ portalInfo.footCopyright }}
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MD5 from 'md5';
import { mapGetters } from 'vuex';
import ENVIRONMENT from '@/utils/environment';
export default {
  name: 'Login',
  data() {
    const pattern = new RegExp(
      "[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]"
    );
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'));
      } else {
        callback();
      }
    };
    const validateUserName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('用户名不能为空'));
      } else if (pattern.test(value)) {
        callback(new Error('不能包含特殊字符'));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        account: '',
        pwd: ''
      },
      loginRules: {
        account: [
          { required: true, trigger: 'blur', validator: validateUserName }
        ],
        pwd: [{ required: true, trigger: 'blur', validator: validatePass }]
      },
      loading: false,
      redirect: undefined,
      pwdType: 'password'
    };
  },
  computed: {
    ...mapGetters(['portalInfo'])
  },
  watch: {
    $route: {
      handler: function(route) {
        this.status = route.query && route.query.status;
        this.status && this.safeLogin();
      },
      immediate: true
    }
  },
  methods: {
    safeLogin() {
      this.loading = false;
      if (this.status === '1') {
        this.$store.dispatch('FedLogOut').then(() => {
          this.$emit('visible', true);
        });
      } else {
        this.$emit('visible', false);
        this.$store.dispatch('GetUserInfo').then(() => {
          this.$emit('visible', false);
          this.$router.push('/');
          // location.reload();
        });
      }
    },
    showPwd() {
      this.pwdType = this.pwdType === 'password' ? '' : 'password';
    },
    // 登录
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          const loginObj = {
            account: this.loginForm.account,
            pwd: MD5(this.loginForm.pwd).toUpperCase()
          };
          this.$store
            .dispatch('Login', loginObj)
            .then(() => {
              // secureOpen="等保策略(0:未开启,1:已开启,2:密码过期)") 未开启不跳转
              this.$store.dispatch('GetUserInfo').then(() => {
                this.loading = false;
                this.$emit('visible', false);
                this.$router.push('/');
                location.reload();
              });
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose() {
      this.$emit('visible', false);
    },
    jumpPage(obj) {
      const url = this.getUrlPath();
      const pwdInfo = {
        secureOpen: obj.secureOpen,
        initialPasswordFlag: obj.initialPasswordFlag,
        account: this.loginForm.account,
        pwd: this.loginForm.pwd
      };
      var result = btoa(JSON.stringify(pwdInfo));
      window.location.href =
        ENVIRONMENT.safeUrl +
        '?pwdInfo=' +
        result +
        '&url=' +
        encodeURIComponent(url) +
        '&sysName=' +
        document.title;
    },
    // 获取url路径
    getUrlPath() {
      // 获取当前网址
      const path = window.document.location.href; // 获取主机地址之后的目录
      const currentPath = encodeURIComponent(path.split('?')[0]);
      // const pathName = window.document.location.pathname;
      return currentPath;
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
$bg: #2d3a4b;
$light_gray: #eee;

/* reset element-ui css */
.login-container {
  .el-form-item {
    .el-form-item__label {
      font-size: 16px;
      font-weight: normal;
      color: #333;
    }
    .el-form-item__content {
      background: #fff;
      border: 1px solid #eeeeee;
      border-radius: 8px;
    }
    .el-input {
      display: inline-block;
      height: 50px;
      width: calc(100% - 45px);
      input {
        background: transparent;
        border: 0px;
        // border-bottom: 1px solid #d1d1d1;
        -webkit-appearance: none;
        border-radius: 0px;
        padding: 12px 5px;
        // color: $light_gray;
        height: 50px;

        &:-webkit-autofill {
          box-shadow: 0 0 0px 1000px #fff inset !important;
          -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
          -webkit-text-fill-color: #454545 !important;
        }
      }
    }
  }
}
.login-body-h5 {
  background: #fff;
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 555;
}

/* reset element-ui css */
.login-container-h5 {
  .el-form-item {
    padding: 20px 4px 0px;
    margin-bottom: 0;

    .el-form-item__label {
      font-size: 16px;
      font-weight: normal;
      color: #333;
    }

    .el-form-item__content {
      background: #fff;
      border-bottom: 1px solid #eeeeee;
      // border-radius: 8px;
    }

    .el-input {
      display: inline-block;
      height: 50px;
      width: calc(100% - 45px);

      input {
        background: transparent;
        border: 0px;
        // border-bottom: 1px solid #d1d1d1;
        -webkit-appearance: none;
        border-radius: 0px;
        padding: 12px 5px;
        // color: $light_gray;
        height: 50px;

        &:-webkit-autofill {
          box-shadow: 0 0 0px 1000px #fff inset !important;
          -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
          -webkit-text-fill-color: #454545 !important;
        }
      }
    }
  }
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
.login-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  z-index: 102;
  overflow: auto;
  &::after {
    content: '';
    display: block;
    height: 100%;
    width: 1200px;
    background: url('~@/assets/img/bg.png') no-repeat center center;
    // background-size: cover;
    position: absolute;
    top: 0;
    bottom: 0;
    left: calc((100% - 1200px) / 2);
    right: calc((100% - 1200px) / 2);
  }
  .overflow-bg {
    position: absolute;
    left: 0;
    bottom: 10%;
  }
  .login-container-middle {
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
    background: #f8f8f8;
    height: 100%;
    width: 40%;
  }
  .login-main {
    position: relative;
    top: 50%;
    z-index: 3;
    width: 1040px;
    height: 510px;
    margin: auto;
    background: transparent;
    margin-top: -300px;
    padding: 52px;
    .close {
      position: absolute;
      right: 24px;
      color: #dddddd;
      margin-top: 10px;
      cursor: pointer;
      &:hover{
        color:  #007afc
      }
    }
    .login-left {
      float: left;
      .logo {
        margin-top: 30px;
        .logoImg {
          display: inline-block;
          width: 170px;
          height: 20px;
          line-height: 65px;
          background-size: 100% 100%;
        }
        p {
          margin-top: 20px;
          font-size: 30px;
          color: #fff;
        }
      }
      .text-sub {
        color: #cde8ff;
        margin-top: 80px;
        h1 {
          width: 34px;
          height: 5px;
          background: #cde8ff;
          margin: 0;
        }
        .cn {
          padding: 20px 0;
          font-size: 20px;
        }
        .en {
          width: 100px;
          font-size: 12px;
          line-height: 24px;
        }
      }
    }
    .login-form {
      width: 364px;
      float: right;
      margin-top: 30px;
      .login-title {
        margin-bottom: 72px;
        color: #007afc;
        font-size: 22px;
        .title-en {
          display: inline-block;
          margin-left: 14px;
          font-size: 16px;
          color: #999999;
        }
      }
      .svg-container {
        padding: 0px 5px 0 10px;
        color: #889aa4;
        vertical-align: middle;
        width: 30px;
        display: inline-block;
        font-size: 16px;
        .svg-icon {
          fill: #e2e2e2;
        }
      }
      .show-pwd {
        position: absolute;
        right: 10px;
        top: 7px;
        font-size: 16px;
        color: $dark_gray;
        cursor: pointer;
        user-select: none;
        .svg-icon {
          fill: #e2e2e2;
        }
      }
      .login-bnt {
        margin-top: 22px;
        button {
          width: 100%;
          height: 50px;
          font-size: 16px;
        }
      }
      .copy-right {
        text-align: center;
        width: 276px;
        font-size: 13px;
        font-weight: 500;
        color: #999999;
        line-height: 20px;
        margin: 0 auto;
        margin-top: 60px;
      }
    }
    .tip {
      font-size: 15px;
      color: #b9bed1;
      line-height: 25px;
    }
  }
}
.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
  z-index: 101;
}
.login-container-h5 {
  background: url('~@/assets/img/login-h5bg.png') no-repeat center center;
  background-size: cover;
  padding: 60px 16px;

  .p1 {
    font-size: 38px;
    line-height: 54px;
    color: #fff;
    font-weight: bold;
    padding-left: 10px;
  }

  .p2 {
    font-size: 12px;
    line-height: 20px;
    color: #fff;
    font-weight: 400;
    padding-left: 10px;
  }

  .login-main {
    border-radius: 10px;
    background: #fff;
  }

  .login-form {
    width: 100%;
    margin-top: 36px;
    padding: 0 8px;

    .svg-container {
      padding: 0px 5px 0 10px;
      color: #889aa4;
      vertical-align: middle;
      width: 30px;
      display: inline-block;
      font-size: 16px;

      .svg-icon {
        fill: #e2e2e2;
      }
    }

    .show-pwd {
      position: absolute;
      right: 10px;
      top: 7px;
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
      user-select: none;

      .svg-icon {
        fill: #e2e2e2;
      }
    }

    .login-bnt {
      margin-top: 14px;

      button {
        width: 100%;
        height: 50px;
        font-size: 16px;
        // background: #2858E0;
        border-radius: 8px;
      }
    }

    .copy-right {
      right: 0;
      left: 0;
      bottom: 36px;
      position: fixed;
      text-align: center;
      width: 276px;
      font-size: 13px;
      font-weight: 500;
      color: #666;
      line-height: 20px;
      margin: 0 auto;
      margin-top: 60px;
    }
  }

  .tip {
    font-size: 14px;
    color: #666;
    line-height: 25px;
    padding-left: 14px;
    margin-top: 18px;
  }

}
.login-body-h5 {display: none;}
@media screen and (max-width: 768px) {
  .login-body {
    display: none;
  }

  .login-body-h5 {
    display: block;
  }
}
</style>
